import type { NotificationSoundPreferences } from "@superagents/types/api";

// Quem nunca salvou ouve as duas (o backend devolve isso já resolvido; aqui só
// cobre o usuário ainda sem o campo, enquanto o deploy não chega).
export const DEFAULT_NOTIFICATION_SOUND_PREFERENCES: NotificationSoundPreferences =
  {
    incoming_message: true,
    directed_chat: true,
  };

export const NOTIFICATION_SOUND_RULES: {
  key: keyof NotificationSoundPreferences;
  label: string;
  hint: string;
}[] = [
  {
    key: "incoming_message",
    label: "Mensagem nova em conversa que você atende",
    hint: "Toca quando um cliente em atendimento com você responde.",
  },
  {
    key: "directed_chat",
    label: "Conversa direcionada a você ou à sua área",
    hint: "Toca quando uma conversa entra na sua fila de atendimento.",
  },
];
